export default __webpack_public_path__ + "static/media/portfolio-github.36e46eb7.png";